module.exports = "<div class=\"alert {{type}} alert-dismissable \" [ngClass]=\"{'fade in': view, 'close-alert': !view}\">\r\n  <button type=\"button\" class=\"close\" (click)=\"close()\">\r\n    <span aria-hidden=\"true\">×</span>\r\n  </button>\r\n  {{text}}\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/alert-text/alert-text.component.html
// module id = 2582
// module chunks = 66